import styled from "styled-components";

const HyperLink = styled.a`
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    text-decoration: underline;
    text-underline-position: under;
    text-underline-offset: 1px;
    color: var(--grey-6);
    display: -webkit-box;
    word-break: break-word;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: pointer;
`

export default HyperLink;
